<template>
  <div class="vc-custom">
    <div class="vc-card-list">
      <div class="vc-scroll pb-2">
        <v-card class="com-pc-card">
          <v-row class="com-pc-card-header">
            <span class="com-pc-card-title">{{ text.individualSetOb }}</span>
          </v-row>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.stage }}</div>
              <v-switch
                class="ma-0"
                v-model="stage"
                inset
                color="success"
                hide-details
                readonly
                :label="stage ? text.show : text.hide"
                @click="stage = !stage"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="d-flex flex-column justify-center pa-0 pl-4 ml-auto"
            >
              <v-row>
                <v-col class="d-flex align-center justify-start px-0 pt-0">
                  <v-checkbox
                    v-model="baseObsOnly"
                    hide-details
                    class="ma-0"
                    :disabled="!stage"
                  ></v-checkbox>
                  <span>{{ text.baseObsOnly }}</span>
                </v-col>
              </v-row>
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="stageZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(stage)"
                  :tick-size="stage ? 5 : 0"
                  :disabled="!stage"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(stage)"
                      @click="stageZm -= 1"
                      :disabled="stageZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(stage)"
                      @click="stageZm += 1"
                      :disabled="maxZoom <= stageZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="stage && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.swin }}</div>
              <v-switch
                class="ma-0"
                v-model="swin"
                inset
                color="success"
                hide-details
                @click="swin = !swin"
                :label="swin ? text.show : text.hide"
                readonly
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="swinZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(swin)"
                  :tick-size="swin ? 5 : 0"
                  :disabled="!swin"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(swin)"
                      @click="swinZm -= 1"
                      :disabled="swinZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(swin)"
                      @click="swinZm += 1"
                      :disabled="maxZoom <= swinZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="swin && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class=""></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.dam }}</div>
              <v-switch
                class="ma-0"
                v-model="dam"
                inset
                color="success"
                hide-details
                @click="dam = !dam"
                :label="dam ? text.show : text.hide"
                readonly
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="damZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(dam)"
                  :tick-size="dam ? 5 : 0"
                  :disabled="!dam"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(dam)"
                      @click="damZm -= 1"
                      :disabled="damZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(dam)"
                      @click="damZm += 1"
                      :disabled="maxZoom <= damZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="dam && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class=""></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.rain }}</div>
              <v-switch
                class="ma-0"
                v-model="rain"
                inset
                color="success"
                hide-details
                readonly
                :label="rain ? text.show : text.hide"
                @click="rain = !rain"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="rainZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(rain)"
                  :tick-size="rain ? 5 : 0"
                  :disabled="!rain"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(rain)"
                      @click="rainZm -= 1"
                      :disabled="rainZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(rain)"
                      @click="rainZm += 1"
                      :disabled="maxZoom <= rainZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="rain && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class=""></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.cctv }}</div>
              <v-switch
                class="ma-0"
                v-model="cctv"
                inset
                color="success"
                hide-details
                readonly
                :label="cctv ? text.show : text.hide"
                @click="cctv = !cctv"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="cctvZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(cctv)"
                  :tick-size="cctv ? 5 : 0"
                  :disabled="!cctv"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(cctv)"
                      @click="cctvZm -= 1"
                      :disabled="cctvZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(cctv)"
                      @click="cctvZm += 1"
                      :disabled="maxZoom <= cctvZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="cctv && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class=""></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.scam }}</div>
              <v-switch
                class="ma-0"
                v-model="scam"
                inset
                color="success"
                hide-details
                readonly
                :label="scam ? text.show : text.hide"
                @click="scam = !scam"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="scamZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(scam)"
                  :tick-size="scam ? 5 : 0"
                  :disabled="!scam"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(scam)"
                      @click="scamZm -= 1"
                      :disabled="scamZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(scam)"
                      @click="scamZm += 1"
                      :disabled="maxZoom <= scamZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="scam && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class=""></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>
                {{ text.wtrQual }}
              </div>
              <v-switch
                class="ma-0"
                v-model="wtrQual"
                inset
                color="success"
                hide-details
                readonly
                :label="wtrQual ? text.show : text.hide"
                @click="wtrQual = !wtrQual"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="wtrQualZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(wtrQual)"
                  :tick-size="wtrQual ? 5 : 0"
                  :disabled="!wtrQual"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(wtrQual)"
                      @click="wtrQualZm -= 1"
                      :disabled="wtrQualZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(wtrQual)"
                      @click="wtrQualZm += 1"
                      :disabled="maxZoom <= wtrQualZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="wtrQual && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.coast }}</div>
              <v-switch
                class="ma-0"
                v-model="coast"
                inset
                color="success"
                hide-details
                readonly
                :label="coast ? text.show : text.hide"
                @click="coast = !coast"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="coastZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(coast)"
                  :tick-size="coast ? 5 : 0"
                  :disabled="!coast"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(coast)"
                      @click="coastZm -= 1"
                      :disabled="coastZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(coast)"
                      @click="coastZm += 1"
                      :disabled="maxZoom <= coastZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="coast && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0 vc-list com-pc-card-contents px-4 py-3">
            <v-col cols="4" class="pa-0 d-flex flex-column justify-center">
              <div>{{ text.snow }}</div>
              <v-switch
                class="ma-0"
                v-model="snow"
                inset
                color="success"
                hide-details
                readonly
                :label="snow ? text.show : text.hide"
                @click="snow = !snow"
              ></v-switch>
            </v-col>
            <v-col
              cols="8"
              class="pa-0 pl-4 ml-auto d-flex flex-column justify-center"
            >
              <v-row>
                <span class="">{{ text.startZmLvl }}</span>
              </v-row>
              <v-row>
                <v-slider
                  v-model="snowZm"
                  class="ma-0"
                  :min="minZoom"
                  :max="maxZoom"
                  step="1"
                  :tick-labels="noSliderLabels"
                  hide-details
                  track-color="primary"
                  track-fill-color="gray"
                  :thumb-color="setColor(snow)"
                  :tick-size="snow ? 5 : 0"
                  :disabled="!snow"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :color="setColor(snow)"
                      @click="snowZm -= 1"
                      :disabled="snowZm <= minZoom"
                      >indeterminate_check_box</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :color="setColor(snow)"
                      @click="snowZm += 1"
                      :disabled="maxZoom <= snowZm"
                      >add_box</v-icon
                    >
                  </template>
                </v-slider>
              </v-row>
              <v-row class="vc-custom-slider">
                <div class="vc-custom-slider__icon"></div>
                <div
                  v-for="(label, key) in sliderLabels"
                  :key="key"
                  class="vc-custom-slider__tick-labels"
                >
                  <span
                    class="vc-custom-slider__tick-label"
                    v-if="snow && label.length > 0"
                    >{{ label }}</span
                  >
                </div>
                <div class="vc-custom-slider__icon"></div>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="com-pc-card mt-1">
          <v-row class="com-pc-card-header">
            <span class="com-pc-card-title">{{ text.individualSetRv }}</span>
          </v-row>
          <v-row
            class="pl-4 mx-0 vc-list com-pc-card-contents"
            @click="fldfr = !fldfr"
          >
            <v-col cols="4" class="pa-0 d-flex align-center">
              <div>{{ text.fldfr }}</div></v-col
            >
            <v-col cols="8" class="pa-0 pl-4 ml-auto d-flex justify-end">
              <v-switch
                class="pr-8"
                v-model="fldfr"
                inset
                :label="fldfr ? text.show : text.hide"
                color="success"
                readonly
              ></v-switch
            ></v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row
            class="pl-4 mx-0 vc-list com-pc-card-contents"
            @click="damdsch = !damdsch"
          >
            <v-col cols="4" class="pa-0 d-flex align-center">
              <div>{{ text.damdsch }}</div>
            </v-col>
            <v-col cols="8" class="pa-0 pl-4 ml-auto d-flex justify-end">
              <v-switch
                class="pr-8"
                v-model="damdsch"
                inset
                :label="damdsch ? text.show : text.hide"
                color="success"
                readonly
              ></v-switch
            ></v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row
            v-if="isFldCtl"
            class="pl-4 mx-0 vc-list com-pc-card-contents"
            @click="fldctl = !fldctl"
          >
            <v-col cols="4" class="pa-0 d-flex align-center">
              <div>{{ text.fldctl }}</div>
            </v-col>
            <v-col cols="8" class="pa-0 pl-4 ml-auto d-flex justify-end">
              <v-switch
                class="pr-8"
                v-model="fldctl"
                inset
                :label="fldctl ? text.show : text.hide"
                color="success"
                readonly
              ></v-switch>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import WebStorage from "./../../lib/webStorage.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "vc-custom",
  data() {
    return {
      stage: true,
      swin: true,
      dam: true,
      rain: true,
      cctv: true,
      scam: true,
      wtrQual: true,
      coast: true,
      snow: true,
      fldfr: true,
      damdsch: true,
      fldctl: true,
      stageZm: this.$store.state.app.config.mapConfig.zoomTmStg,
      swinZm: this.$store.state.app.config.mapConfig.zoomTmSwstg,
      damZm: this.$store.state.app.config.mapConfig.zoomTmDam,
      rainZm: this.$store.state.app.config.mapConfig.zoomTmRn,
      cctvZm: this.$store.state.app.config.mapConfig.zoomTmCctv,
      scamZm: this.$store.state.app.config.mapConfig.zoomTmScam,
      wtrQualZm: this.$store.state.app.config.mapConfig.zoomTmQwtr,
      coastZm: this.$store.state.app.config.mapConfig.zoomTmCoast,
      snowZm: this.$store.state.app.config.mapConfig.zoomTmSnw,
      minZoom: this.$store.state.app.config.mapConfig.minZoom,
      maxZoom: this.$store.state.app.config.mapConfig.maxZoom,
      baseObsOnly: false,
      text: {
        individualSetOb: "個別設定（観測所の種類）",
        individualSetRv: "個別設定（河川に関する発表情報）",
        show: "表示",
        hide: "非表示",
        stage: "水位観測",
        swin: this.$store.state.app.config.replaceNameConfig.swstg,
        dam: "ダム諸量",
        rain: "雨量",
        cctv: "河川カメラ",
        scam: "簡易カメラ",
        wtrQual: "水質",
        coast: "海岸",
        snow: "積雪深",
        fldfr: "洪水予報等",
        damdsch: "ダム放流通知",
        fldctl: "水防警報",
        baseObsOnly: "基準観測所のみ適用する",
        startZmLvl: "アイコン表示を開始する地図の縮尺",
      },
      // 表示中の地図縮尺用
      sliderLabels: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      // スライダーバーの目盛り表示用
      noSliderLabels: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    };
  },
  /**
   * マウント前イベント
   */
  beforeMount() {
    // スライダー下部の表示中地図縮尺のラベルを作成する
    this.sliderLabels[this.zoom - this.minZoom] = "▲";
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[VcCustom] mounted()");
    // アクセスログ出力
    PageLog.log({
      page_log: "indsetting",
      device_sb: this.$store.state.app.mode,
      fc_flg: this.$store.getters["app/isFldCtl"],
    });

    // webストレージ読み込み
    let info = WebStorage.getCustomInfo();
    // dataに展開
    this.stage = info.stage;
    this.swin = info.swin;
    this.dam = info.dam;
    this.rain = info.rain;
    this.cctv = info.cctv;
    this.scam = info.scam;
    this.wtrQual = info.wtrQual;
    this.coast = info.coast;
    this.snow = info.snow;
    this.fldfr = info.fldfr;
    this.damdsch = info.damdsch;
    this.fldctl = info.fldctl;
    // 表示開始ズームレベル
    this.stageZm = info.stageZmLvl;
    this.swinZm = info.swinZmLvl;
    this.damZm = info.damZmLvl;
    this.rainZm = info.rainZmLvl;
    this.cctvZm = info.cctvZmLvl;
    this.scamZm = info.scamZmLvl;
    this.wtrQualZm = info.wtrQualZmLvl;
    this.coastZm = info.coastZmLvl;
    this.snowZm = info.snowZmLvl;
    // 基準観測所のみ適用
    this.baseObsOnly = info.baseObsOnly;
  },
  computed: {
    /** 選択値 */
    value: {
      get() {
        return {
          // 表示・非表示
          stage: this.stage,
          swin: this.swin,
          dam: this.dam,
          rain: this.rain,
          cctv: this.cctv,
          scam: this.scam,
          wtrQual: this.wtrQual,
          coast: this.coast,
          snow: this.snow,
          fldfr: this.fldfr,
          damdsch: this.damdsch,
          fldctl: this.fldctl,
          // 表示開始ズームレベル
          stageZmLvl: this.stageZm,
          swinZmLvl: this.swinZm,
          damZmLvl: this.damZm,
          rainZmLvl: this.rainZm,
          cctvZmLvl: this.cctvZm,
          scamZmLvl: this.scamZm,
          wtrQualZmLvl: this.wtrQualZm,
          coastZmLvl: this.coastZm,
          snowZmLvl: this.snowZm,
          // 基準観測所のみ適用
          baseObsOnly: this.baseObsOnly,
        };
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /**
     * webストレージ編集日時
     */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /**
     * 表示ズームレベル
     */
    zoom: {
      get() {
        return this.$store.state.map.zoom;
      },
    },
  },
  methods: {
    /**
     * 戻るボタンクリック
     */
    clickReturn() {
      this.$log.debug("[VcCustom] clickReturn()");
      this.$store.commit("app/setContent", "VcDefault");
    },
    /** 表示・非表示の色設定 */
    setColor(isOn) {
      return isOn ? "primary" : "gray";
    },
  },
  watch: {
    /**
     * 選択地変更時
     */
    value() {
      this.$log.debug("[VcCustom] watch(value)");
      // webストレージ書き込み
      WebStorage.setCustomInfo(this.value);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /**
     * webストレージ編集日時
     */
    editWebStorageDate() {
      this.$log.debug("[VcCustom] watch(editWebStorageDate)");
      // webストレージ読み込み
      let info = WebStorage.getCustomInfo();
      // dataに展開
      this.stage = info.stage;
      this.swin = info.swin;
      this.dam = info.dam;
      this.rain = info.rain;
      this.cctv = info.cctv;
      this.scam = info.scam;
      this.wtrQual = info.wtrQual;
      this.coast = info.coast;
      this.snow = info.snow;
      this.fldfr = info.fldfr;
      this.damdsch = info.damdsch;
      this.fldctl = info.fldctl;
      // 表示開始ズームレベル
      this.stageZm = info.stageZmLvl;
      this.swinZm = info.swinZmLvl;
      this.damZm = info.damZmLvl;
      this.rainZm = info.rainZmLvl;
      this.cctvZm = info.cctvZmLvl;
      this.scamZm = info.scamZmLvl;
      this.wtrQualZm = info.wtrQualZmLvl;
      this.coastZm = info.coastZmLvl;
      this.snowZm = info.snowZmLvl;
      // 基準観測所のみ適用
      this.baseObsOnly = info.baseObsOnly;
    },
    zoom() {
      // スライダー下部の表示中地図縮尺のラベルを作成する
      let tmpArr = Array.from(this.noSliderLabels);
      tmpArr[this.zoom - this.minZoom] = "▲";
      this.sliderLabels = Array.from(tmpArr);
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-custom {
  display: flex;
  flex-direction: column;
  flex: 1;
  .vc-return {
    width: 100px;
    height: 36px;
  }
  .vc-card-list {
    flex: 1;
    position: relative;
  }
  .vc-scroll {
    position: absolute;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}
.vc-list {
  cursor: pointer;
}
</style>
